import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'app-pen-report',
  templateUrl: './pen-report.component.html',
  styleUrl: './pen-report.component.less',
})
export class PenReportComponent implements OnInit {
  @Input() userPen: any;
  @Output() closeReport: EventEmitter<any> = new EventEmitter();
  
  // Array to store SSL test IDs
  sslTestIds: string[] = [];
  
  // Map to store human-friendly key names
  keyNamesMap: { [key: string]: string } = {};
  
  // Control display limits and expansion
  readonly initialDisplayLimit = 4;
  showAllInfo = false;
  showAllPassed = false;

  constructor(private http: HttpClient) {}

  closeReportClick() {
    this.closeReport.emit();
  }

  ngOnInit(): void {
    console.log(this.userPen);
    
    // Load the key names mapping
    this.loadKeyNamesMap();
    
    // Extract SSL test IDs when userPen data is available
    this.extractSslTestIds();
  }
  
  // Toggle showing all INFO items
  toggleShowAllInfo(): void {
    this.showAllInfo = !this.showAllInfo;
  }
  
  // Toggle showing all OK items
  toggleShowAllPassed(): void {
    this.showAllPassed = !this.showAllPassed;
  }
  
  // Get limited or all items based on showAll flag
  getLimitedItems(severity: string): any[] {
    const allItems = this.getItemsBySeverity(severity);
    
    if (severity === 'INFO' && !this.showAllInfo) {
      return allItems.slice(0, this.initialDisplayLimit);
    } else if (severity === 'OK' && !this.showAllPassed) {
      return allItems.slice(0, this.initialDisplayLimit);
    }
    
    return allItems;
  }
  
  // Filter items by severity
  getItemsBySeverity(severity: string): any[] {
    if (!this.userPen?.report?.testSSL?.data?.output) {
      return [];
    }
    
    if (severity === 'WARN') {
      return this.userPen.report.testSSL.data.output.filter((item: any) => item.severity === 'WARN');
    } else if (severity === 'INFO') {
      return this.userPen.report.testSSL.data.output.filter((item: any) => item.severity === 'INFO');
    } else if (severity === 'OK') {
      // Return only items with OK severity
      return this.userPen.report.testSSL.data.output.filter((item: any) => item.severity === 'OK');
    } else if (severity === 'OTHER') {
      // Return items that are neither WARN, INFO, nor OK (any remaining values)
      return this.userPen.report.testSSL.data.output.filter(
        (item: any) => item.severity !== 'WARN' && item.severity !== 'INFO' && item.severity !== 'OK'
      );
    }
    
    return [];
  }
  
  // Load the key names mapping from the JSON file
  loadKeyNamesMap(): void {
    this.http.get<{ [key: string]: string }>('assets/data/pen-key-names.json')
      .subscribe({
        next: (data) => {
          this.keyNamesMap = data;
          console.log('Key names map loaded:', this.keyNamesMap);
        },
        error: (error) => {
          console.error('Error loading key names map:', error);
        }
      });
  }
  
  // Get human-friendly name for a key
  getHumanFriendlyName(key: string): string {
    return this.keyNamesMap[key] || key;
  }
  
  // Method to extract SSL test IDs from the report data
  extractSslTestIds(): void {
    if (this.userPen?.report?.testSSL?.data?.output) {
      // Extract IDs from the SSL test output
      this.sslTestIds = this.userPen.report.testSSL.data.output
        .filter((item: any) => item && item.id) // Filter out items without IDs
        .map((item: any) => item.id); // Extract just the ID field
      
      // Log the array of IDs to the console
      console.log('SSL Test IDs:', this.sslTestIds);
    }
  }
}
